import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import {LocalizationContents} from "../../../LocalizationContents";

export interface IIntroScreenControllerOptions {
}

export class HelpMenuScreenController extends AnimationBaseController {
    $model: GameModel;
    count_frames: number = 1;

    public constructor(@Inject private _options: IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("HelpMenuScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.HELP_SCREEN_JSON,
            libraryName: "help_container",
            childControllers: {
                CloseButtonPage1: {
                    instanceName: "help_page1.background.button_close_change",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.hidenModal();
                            console.log("Close button click");
                        }
                    }
                },
                CloseButtonPage2: {
                    instanceName: "help_page2.background.button_close_change",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.hidenModal();
                            console.log("Close button click");
                        }
                    }
                },
                CloseButtonPage3: {
                    instanceName: "help_page3.background.button_close_change",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.hidenModal();
                            console.log("Close button click");
                        }
                    }
                },
            },
            modelWatch: {},
            onTap: () => {
                this.changeAnimationFrame()
            }
        };

    }


    protected changeAnimationFrame(): void {

        if (this.count_frames === 3) {
            this.count_frames = 0;
        }
        switch (this.count_frames) {

            case 0:
                this.gotoAndPlay("change_page_3_to_1");

                break;
            case 1:
                this.gotoAndPlay("change_page_1_to_2");

                break;
            case 2:
                this.gotoAndPlay("change_page_2_to_3");

                break;
        }

        this.count_frames++;
    }

    protected onInitialize(): void {
        this.display.scale.set(.65);
        this.gotoAndStop("page_first");
        this.setTextByQuery("help_page1.txt_title.header_text_01", LocalizationContents.pause_help);
        this.setTextByQuery("help_page1.txt1.slide_01_text_02", LocalizationContents.slide_01_text_02);
        this.setTextByQuery("help_page1.txt2.slide_01_text_04", LocalizationContents.slide_01_text_04);

        this.setTextByQuery("help_page2.title_column1.slide_02_text_02", LocalizationContents.slide_02_text_02);
        this.setTextByQuery("help_page2.title_column2.slide_02_text_03", LocalizationContents.slide_02_text_03);
        this.setTextByQuery("help_page2.txt_title2.slide_02_text_01", LocalizationContents.slide_02_text_01);
        this.setTextByQuery("help_page2.column1.slide_02_text_04", LocalizationContents.slide_02_text_04);
        this.setTextByQuery("help_page2.count_02_text_04", '0');
        this.setTextByQuery("help_page2.column1.slide_02_text_05", LocalizationContents.slide_02_text_05);
        this.setTextByQuery("help_page2.count_02_text_05", '0');
        this.setTextByQuery("help_page2.column1.slide_02_text_06", LocalizationContents.slide_02_text_06);
        this.setTextByQuery("help_page2.count_02_text_06", '2');
        this.setTextByQuery("help_page2.column1.slide_02_text_07", LocalizationContents.slide_02_text_07);
        this.setTextByQuery("help_page2.count_02_text_07", '1');
        this.setTextByQuery("help_page2.column1.slide_02_text_08", LocalizationContents.slide_02_text_08);
        this.setTextByQuery("help_page2.count_02_text_08", '2');
        this.setTextByQuery("help_page2.column1.slide_02_text_09", LocalizationContents.slide_02_text_09);
        this.setTextByQuery("help_page2.count_02_text_09", '3');

        this.setTextByQuery("help_page3.txt_title3.slide_03_text_01", LocalizationContents.slide_03_text_01);
        this.setTextByQuery("help_page3.txt_page3_1.slide_03_text_02", LocalizationContents.slide_03_text_02);
        this.setTextByQuery("help_page3.txt_page3_2.slide_03_text_05", LocalizationContents.slide_03_text_05);
        this.setTextByQuery("help_page3.txt_page3_1_1.slide_03_text_03", LocalizationContents.slide_03_text_03);
        this.setTextByQuery("help_page3.txt_page3_2_1.slide_03_text_06", LocalizationContents.slide_03_text_06);
    }

    protected onAnimationEvent(name: string, ...args) {
        if (name === "finishAnimation") {
            this.gotoAndStop("page_first");
        }
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

